import React, { useState } from "react";
import {
  Button,
  Card,
  CardBody,
  CardHeader,
  FormControl,
  FormLabel,
  Heading,
  Input,
  NumberInput,
  NumberInputField,
  Select,
  SimpleGrid,
  Textarea,
} from "@chakra-ui/react";

const initialForm = {
  name: "",
  description: "",
  amount: 0,
  currency: "USD",
  intervalUnit: "MONTH",
  intervalCount: 1,
};

const CreatePlanPanel = ({ onSubmit, isSubmitting }) => {
  const [form, setForm] = useState(initialForm);

  const handleChange = (field, value) => {
    setForm((prev) => ({ ...prev, [field]: value }));
  };

  const handleSubmit = async () => {
    const success = await onSubmit({
      ...form,
      amount: Number(form.amount || 0),
      intervalCount: Number(form.intervalCount || 1),
    });
    if (success) {
      setForm(initialForm);
    }
  };

  return (
    <Card variant="outline" _hover={{ boxShadow: "md" }} transition="box-shadow 0.2s ease">
      <CardHeader>
        <Heading size="sm">Create Subscription Plan</Heading>
      </CardHeader>
      <CardBody>
        <SimpleGrid columns={{ base: 1, md: 2 }} spacing={4}>
          <FormControl>
            <FormLabel>Plan Name</FormLabel>
            <Input value={form.name} onChange={(e) => handleChange("name", e.target.value)} />
          </FormControl>
          <FormControl>
            <FormLabel>Amount</FormLabel>
            <NumberInput
              min={0}
              precision={2}
              value={form.amount}
              onChange={(_, valueNumber) => handleChange("amount", Number.isFinite(valueNumber) ? valueNumber : 0)}
            >
              <NumberInputField />
            </NumberInput>
          </FormControl>
          <FormControl>
            <FormLabel>Currency</FormLabel>
            <Select value={form.currency} onChange={(e) => handleChange("currency", e.target.value)}>
              <option value="USD">USD</option>
              <option value="EUR">EUR</option>
              <option value="GBP">GBP</option>
              <option value="INR">INR</option>
            </Select>
          </FormControl>
          <FormControl>
            <FormLabel>Interval Unit</FormLabel>
            <Select value={form.intervalUnit} onChange={(e) => handleChange("intervalUnit", e.target.value)}>
              <option value="MONTH">MONTH</option>
              <option value="YEAR">YEAR</option>
            </Select>
          </FormControl>
          <FormControl>
            <FormLabel>Interval Count</FormLabel>
            <NumberInput
              min={1}
              value={form.intervalCount}
              onChange={(_, valueNumber) => handleChange("intervalCount", Number.isFinite(valueNumber) ? valueNumber : 1)}
            >
              <NumberInputField />
            </NumberInput>
          </FormControl>
          <FormControl gridColumn={{ md: "1 / -1" }}>
            <FormLabel>Description</FormLabel>
            <Textarea value={form.description} onChange={(e) => handleChange("description", e.target.value)} />
          </FormControl>
        </SimpleGrid>
        <Button mt={4} colorScheme="blue" onClick={handleSubmit} isLoading={isSubmitting}>
          Create Plan
        </Button>
      </CardBody>
    </Card>
  );
};

export default CreatePlanPanel;
